import api from './api';

export interface TaskTemplate {
  id: number;
  name: string;
  task_type_id?: number;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  taskType?: {
    id: number;
    name: string;
  };
  task_type?: {
    id: number;
    name: string;
  };
  subTaskTemplates?: Array<{
    id: number;
    name: string;
    enabled: boolean;
    list_type?: 'general' | 'check_in' | 'check_out' | string;
  }>;
  sub_task_templates?: Array<{
    id: number;
    name: string;
    enabled: boolean;
    list_type?: 'general' | 'check_in' | 'check_out' | string;
  }>;
}

export interface CreateTaskTemplateData {
  name: string;
  task_type_id?: number;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const taskTemplateService = {
  async getAll(params?: { page?: number; per_page?: number }) {
    const response = await api.get('/task-templates', { params });
    return response.data;
  },

  async getById(id: number): Promise<TaskTemplate> {
    const response = await api.get(`/task-templates/${id}`);
    return unwrap<TaskTemplate>(response);
  },

  async create(data: CreateTaskTemplateData): Promise<TaskTemplate> {
    const response = await api.post('/task-templates', data);
    return unwrap<TaskTemplate>(response);
  },

  async update(id: number, data: Partial<CreateTaskTemplateData>): Promise<TaskTemplate> {
    const response = await api.put(`/task-templates/${id}`, data);
    return unwrap<TaskTemplate>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/task-templates/${id}`);
  },
  async batchDelete(payload: { ids?: number[]; select_all?: boolean; excluded_ids?: number[] }) {
    const response = await api.post('/task-templates/batch-delete', payload);
    return response.data;
  },
};
